// extracted by mini-css-extract-plugin
module.exports = {"searchLimitWarning":"SearchLimitWarning_searchLimitWarning__zuxDA"};